var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-pill px-2 py-1",class:_vm.activeClass},[_c('span',{staticClass:"fas fa-circle small"}),_vm._v("\n  "+_vm._s(_vm.holiday.status === 1 ? 'activo' : 'inactivo')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }